import { AppConfig } from "../utils/AppConfig.js";
import { ApiService } from "../utils/ApiService.js";
import { etiquetaSucursal, excluirSucursales } from "./sucursalesReglas.js";

// Catálogo de sucursales. Sale directo de LCApii, que lo expone público: la API
// propia ya no lo proxea (ese proxy existía solo para esconder un Bearer
// hardcodeado en el código del servidor).

const ENDPOINT = () => `${AppConfig.lcapii.url.replace(/\/$/, "")}/api/sucursales`;

export const SucursalesService = {
  /**
   * Activas, con su `etiqueta` para mostrar ("Nombre - NN", con el alias de
   * `datosSistema` aplicado) y ordenadas por el nombre mostrado. `nombre`
   * queda intacto: es el de LCApii y es el que se congela en el registro.
   * Cacheadas 12 h, como hacía la app anterior.
   */
  async listar(alias = {}) {
    const data = await ApiService.makeRequest("GET", ENDPOINT(), null, null, {
      cacheTiempo: "12h",
      cachePersistent: true,
    });

    return (Array.isArray(data) ? data : [])
      .filter((s) => s.activo === true)
      .map((s) => ({ ...s, ...etiquetaSucursal(s, alias) }))
      .sort((a, b) => a.nombreMostrado.localeCompare(b.nombreMostrado));
  },

  /**
   * Saca primero las excluidas por el sistema (`datosSistema`) y después filtra
   * por la lista de ids permitidos del usuario. La lista vacía no significa
   * "todas": un 0 en la lista es el comodín que LCApii usa para "sin
   * restricción", y ni ese comodín trae de vuelta una excluida.
   */
  filtrarPermitidas(sucursales, permitidas, excluidas = []) {
    const disponibles = excluirSucursales(sucursales, excluidas);

    if (!Array.isArray(permitidas) || permitidas.length === 0) return [];
    if (permitidas.includes(0)) return disponibles;

    // Comparación por id numérico. La app anterior guardaba las listas como
    // texto y las consultaba con includes(), que busca subcadenas: con "10"
    // permitido, includes(0) daba verdadero y habilitaba todas las sucursales.
    const ids = permitidas.map((p) => Number(p));
    return disponibles.filter((s) => ids.includes(Number(s.id)));
  },
};
